import React, { Component } from "react";
import AddToCartIcon from "../../assets/addtocart.svg";
import styled from "styled-components";
import { addProduct } from "../../redux/features/cartSlice";
import { connect } from "react-redux";
import { withRouter } from "../../withRouter";
import { mapStateToProps } from "../../redux/store";
const AddImage = styled.img`
  height: 50px;
  width: 50px;
  position: absolute;
  bottom: -25px;
  right: 0;
  display: ${({ inStock }) => (inStock ? "block" : "none")};
  cursor: pointer;
  z-index: 100;
  @media (hover: hover) {
    opacity: 0;
  }
`;
const Container = styled.div`
  cursor: pointer;
  padding: 1rem;
  width: 350px;
  @media (hover: hover) {
    &:hover ${AddImage} {
      opacity: 1;
    }
  }
`;
const ProductImage = styled.div`
  margin-bottom: 2rem;
  position: relative;
`;
const Out = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  color: #8d8f9a;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  text-align: center;
  font-size: 1.5rem;
  background-color: rgba(255, 255, 255, 0.5);
`;
const Image = styled.img`
  height: 330px;
  width: 100%;
  object-fit: contain;
`;

const ProductName = styled.div`
  font-size: 1.125rem;
  font-weight: 300;
  margin-bottom: 1rem;
`;
const ProductPrice = styled.div`
  font-size: 1.125rem;
  font-weight: 500;
`;
class Product extends Component {
  render() {
    if (this.props.productDetails) {
      const { id, brand, name, prices, gallery, inStock, attributes } =
        this.props.productDetails;
      const { __typename, description, ...cartProduct } =
        this.props.productDetails;
      const defaultAttributes = attributes.reduce((obj, attribute) => {
        return { ...obj, [attribute.name]: attribute.items[0].value };
      }, {});
      const selectedPrice = prices.find(
        (price) => price.currency.label === this.props.currencyState.label
      );
      return (
        <Container onClick={() => this.props.navigate(`/product/${id}`)}>
          <ProductImage>
            <Image src={gallery[0]} />
            {!inStock && <Out>OUT OF STOCK</Out>}
            <AddImage
              inStock={inStock}
              src={AddToCartIcon}
              onClick={(event) => {
                event.stopPropagation();
                this.props.dispatch(
                  addProduct({
                    productDetails: {
                      ...cartProduct,
                      selectedAttributes: defaultAttributes,
                    },
                  })
                );
              }}
            />
          </ProductImage>
          <ProductName>
            {brand} {name}
          </ProductName>
          <ProductPrice>
            {selectedPrice.currency.symbol}
            {selectedPrice.amount.toFixed(2)}
          </ProductPrice>
        </Container>
      );
    }
  }
}
export default withRouter(connect(mapStateToProps)(Product));
